export const selectDaysBack = (state) => state.agentsDashboard.daysBack
export const selectPageVisible = (state) => state.agentsDashboard.pageVisible

export const selectDashboard = (state) => state.agentsDashboard.dashboard
export const selectPerformance = (state) => state.agentsDashboard.performance
export const selectDmarc = (state) => state.agentsDashboard.dmarc
export const selectRedirects = (state) => state.agentsDashboard.redirects
export const selectAdoption = (state) => state.agentsDashboard.adoption
export const selectTrendsOverview = (state) => state.agentsDashboard.trendsOverview
export const selectBriefing = (state) => state.agentsDashboard.briefing
export const selectFeedItems = (state) => state.agentsDashboard.feed.items
export const selectFeedCursor = (state) => state.agentsDashboard.feed.cursor
export const selectFeedLoaded = (state) => state.agentsDashboard.feed.loaded

export const selectLoading = (state) => state.agentsDashboard.loading
export const selectError = (state) => state.agentsDashboard.error
